import React from 'react'

const Heap = () => {
  return (
    <div>
        <iframe src="https://visualgo.net/en/heap" width="100%" height="920px" title="Heap"></iframe>
    </div>
  )
}

export default Heap